import React from 'react'

const Loading = () => {
    console.count('loading');
    return (
        <section>
            Loading...
        </section>
    )
}

export default Loading
